import { render, staticRenderFns } from "./eventReportDialog.vue?vue&type=template&id=47af525b&"
import script from "./eventReportDialog.vue?vue&type=script&lang=js&"
export * from "./eventReportDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports